import { gsap } from "gsap";

export default () => ({
    parts: [],
    tween: null,
    resetVelocity: null,
    returnTween: null,
    removeLenisListener: null,
    direction: 1,

    init() {
        this.parts = this.$el.querySelectorAll('.marquee__part');
        this.tween = gsap.to(this.parts, {
            xPercent: -100,
            repeat: -1,
            duration: 20,
            ease: "linear",
        }).totalProgress(0.5);

        this.bindLenisVelocity();
    },

    bindLenisVelocity() {
        const lenis = window.lenis;

        if (!lenis?.on) {
            return;
        }

        const maxBoost = 5;
        const boostMultiplier = 2;

        this.resetVelocity = gsap.delayedCall(0.18, () => {
            this.returnTween = gsap.to(this.tween, {
                timeScale: this.direction,
                duration: 0.45,
                ease: "power3.out",
                overwrite: true,
            });
        }).pause();

        const onScroll = ({ velocity = 0 }) => {
            const boost = gsap.utils.clamp(1, maxBoost, 1 + Math.abs(velocity) * boostMultiplier);

            if (velocity !== 0) {
                this.direction = velocity > 0 ? 1 : -1;
            }

            this.returnTween?.kill();
            this.tween.timeScale(boost * this.direction);
            this.resetVelocity.restart(true);
        };

        this.removeLenisListener = lenis.on("scroll", onScroll);
    },

    destroy() {
        this.removeLenisListener?.();
        this.resetVelocity?.kill();
        this.returnTween?.kill();
        this.tween?.kill();
    },
});
